import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { accordionInterface } from 'src/app/util/interfaces/accordion';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { environment } from 'src/environments/environment';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class CustomAccordionService {
	private getAccordion = environment.baseApiUrl + 'register/customAccordion';
	private postAccordion = environment.baseApiUrl + 'register/customAccordion';
	private putAccordion = environment.baseApiUrl + 'register/customAccordion';
	private deleteAccordion = environment.baseApiUrl + 'register/customAccordion';

	private getFormOptionsUrl = environment.baseApiUrl + 'report/paramsAccordionFor';
	private getRequestFormItemsUrl = environment.baseApiUrl + 'report/paramsAccordionFor/item';

	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	constructor(
		private AuthLoginService: AuthLoginService,
		private http: HttpClient
	) {}

	getUserAccordion(): Observable<accordionInterface[]> {
		return this.http.get<accordionInterface[]>(this.getAccordion, { headers: this.headers });
	}

	createCustomAccordion(accordion: accordionInterface): Observable<any> {
		return this.http.post<any>(this.postAccordion, accordion, { headers: this.headers });
	}

	updateCustomAccordion(accordion: accordionInterface): Observable<any> {
		return this.http.put<any>(this.putAccordion, accordion, { headers: this.headers });
	}

	deleteCustomAccordion(idAccordion: string): Observable<any> {
		const deleteAccordion = this.deleteAccordion + '?id=' + idAccordion;
		return this.http.delete<any>(deleteAccordion, { headers: this.headers });
	}

	getFormOptions(parameterType: string, grabItems: boolean): Observable<genericFormInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.http
			.get<JSON[]>(this.getFormOptionsUrl, { headers: headers, params: { paramType: parameterType, grabItems: grabItems } })
			.pipe(
				map((formOptionsRes) => {
					const newFormOptionsArray: genericFormInterface[] = [];
					formOptionsRes.forEach((formOption: any) => {
						const newFormOption: genericFormInterface = {
							id: formOption.id,
							inputType: formOption.inputType,
							name: formOption.name,
							label: formOption.label,
							items: formOption.items,
							values: formOption.values,
							rawValues: formOption.rawValues,
							disabled: formOption.disabled,
							outItems: [],
							filterItem: [],
							filterValues: [],
						};

						newFormOptionsArray.push(newFormOption);
					});

					return newFormOptionsArray;
				})
			);
	}

	getFormItem(formItemName: string): any {
		const getRequestFormItemsUrl = this.getRequestFormItemsUrl + '?paramName=' + formItemName;
		return this.http.get<JSON>(getRequestFormItemsUrl, { headers: this.headers });
	}
}
